import type { ResolvedUserConfig, UserConfig } from '../types/userConfig';
import { parseUserConfigJson, resolveUserConfig } from './userConfigModel';

export const USER_CONFIG_BOOTSTRAP_CACHE_KEY = 'liks-user-config-bootstrap';

export function readUserConfigBootstrapCache(): UserConfig {
  if (typeof window === 'undefined') {
    return {};
  }

  const stored = sessionStorage.getItem(USER_CONFIG_BOOTSTRAP_CACHE_KEY);
  if (stored === null) {
    return {};
  }

  return parseUserConfigJson(stored);
}

export function resolveBootstrapUserConfig(): ResolvedUserConfig {
  return resolveUserConfig(readUserConfigBootstrapCache());
}

export function writeUserConfigBootstrapCache(updates: UserConfig): void {
  if (typeof window === 'undefined') {
    return;
  }

  const current = readUserConfigBootstrapCache();
  sessionStorage.setItem(
    USER_CONFIG_BOOTSTRAP_CACHE_KEY,
    JSON.stringify({ ...current, ...updates }),
  );
}

export function clearUserConfigBootstrapCache(): void {
  if (typeof window === 'undefined') {
    return;
  }

  sessionStorage.removeItem(USER_CONFIG_BOOTSTRAP_CACHE_KEY);
}
